import { z } from 'zod'

export const documentNewSchema = z.object({
  subjectType: z.string().optional(),
  subjectName: z.string().optional(),
  companyId: z.number().optional(),
  contactId: z.number().optional(),
  licenseId: z.number().optional(),
  bankAccountId: z.number().optional(),
  returnUrl: z.string().optional()
})
